<template>
  <login-layout>
    <b-container class="py-4 c-login-container">
      <b-alert
        variant="danger"
        dismissible
        :show="validationAlerts.length > 0"
        @hide="dismissed = true"
      >
        <li v-for="(validationAlert, i) in validationAlerts" :key="i">
          {{ validationAlert }}
        </li>
      </b-alert>
      <b-media>
        <div style="padding: .40em">
          <img
            src="@/assets/logo-vitalliance-2026.svg"
            alt="Vitalliance"
            width="175"
            height="40"
          />
          <h1 class="h2 d-inline-block">{{ $t("client-web-name") }}</h1>
          <p class="text-muted">
            {{ $t("login-sub-title") }}
          </p>
        </div>

        <b-media v-if="isLoading" class="mb-3 text-center">
          <spinner height="128" width="128"></spinner>
        </b-media>
        <b-card class="mb-3 shadow">
          <b-form @keyup.enter="onSubmit">
            <b-form-group :label="$t('login-username')" label-for="name">
              <b-form-input
                id="username"
                type="text"
                :placeholder="user.username"
                v-model="user.username"
                ref="username"
              >
              </b-form-input>
            </b-form-group>
            <b-form-group :label="$t('login-password')" label-for="password">
              <b-form-input
                id="password"
                type="password"
                v-model="user.password"
              >
              </b-form-input>
            </b-form-group>

            <b-button @click="onSubmit" variant="primary" block>{{
              $t("login-submit-btn")
            }}</b-button>
          </b-form>
        </b-card>

        <p class="text-center">
          {{ $t("login-description") }}
        </p>
      </b-media>
    </b-container>
  </login-layout>
</template>

<script>
import LoginLayout from "../layouts/LoginLayout.vue";
import Spinner from "./Helpers/Spinner/Spinner.vue";
import conditionService from "../services/condition";
import notiService from "../services/notification";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    LoginLayout,
    Spinner
  },
  data: function() {
    return {
      user: {
        username: "",
        password: ""
      },
      validationAlerts: [],
      errors: []
    };
  },
  computed: {
    ...mapGetters(["isLoading"])
  },
  mounted() {
    this.$refs.username.focus();
  },
  methods: {
    ...mapActions("auth", ["login", "smartRedirect"]),
    isValidForm() {
      if (this.user.username == "") {
        this.validationAlerts.push(this.$t("login-empty-username"));
        return false;
      }

      if (this.user.password == "") {
        this.validationAlerts.push(this.$t("login-empty-pass"));
        return false;
      }

      return true;
    },
    onSubmit() {
      // promise

      this.validationAlerts = [];
      if (!this.isValidForm()) {
        return;
      }
      this.login({ username: this.user.username, password: this.user.password })
        .then(response => {
          if (!response.success) {
            this.validationAlerts.push(response.message);
          } else {
            const { pkIxAntenne, email } = response.data;
            this.getConditions(email, pkIxAntenne);
            this.getNotiConfig();
          }
        })
        .then(() => {
          this.user.username = "";
          this.user.password = "";
        });
    },
    getConditions(email, pkAgency) {
      conditionService.getCondition(email, pkAgency).then(res => {
        if (res.success) {
          localStorage.setItem("conditions", JSON.stringify(res.activation));
          this.smartRedirect();
        }
      });
    },
    getNotiConfig() {
      notiService.getNoticonfig().then(res => {
        localStorage.setItem("notificationConfig", JSON.stringify(res));
      });
    }
  }
};
</script>

<style lang="scss">
.c-login-container {
  max-width: 460px;
}
</style>
